@for (file of files; track file) {
  <div class="file">
    <fa-icon
      class="type-icon"
      [icon]="getFileTypeIcon(file.output_format.name)"
    ></fa-icon>
    <a [href]="downloadLog(file.name)">{{ file.base_name }}</a>
    <fa-icon [icon]="['fas', 'download']"></fa-icon>
  </div>
}
